// extracted by mini-css-extract-plugin
export var container = "CategoryList-module--container--869dd";
export var isSlider = "CategoryList-module--isSlider--e1f57";
export var slider = "CategoryList-module--slider--0b1c9";
export var wrapper = "CategoryList-module--wrapper--e05fb";